$('.btn, .button').each( function() {
    if( $(this).find('.btn__arrow').length == 0 ) {
        $(this).prepend('<div class="btn__arrow"><i class="icon icon-arrow"></i></div>');
    }
});
